export const HeaderButton = ({ text, onClick }) => {
    return (
        <a href={`#${text.toLowerCase()}`} className="w-full h-full text-xl p-5 hover:bg-slate-900">
            <button onClick={onClick} className="w-full h-full hover:bg-slate-900">
                {text}
            </button>
        </a>
    )
}